/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FamilyPoolInvitation } from './FamilyPoolInvitation';
import {
    FamilyPoolInvitationFromJSON,
    FamilyPoolInvitationFromJSONTyped,
    FamilyPoolInvitationToJSON,
    FamilyPoolInvitationToJSONTyped,
} from './FamilyPoolInvitation';

/**
 * 
 * @export
 * @interface FamilyPoolInvitationResponse
 */
export interface FamilyPoolInvitationResponse {
    /**
     * 
     * @type {FamilyPoolInvitation}
     * @memberof FamilyPoolInvitationResponse
     */
    invitation?: FamilyPoolInvitation;
}

/**
 * Check if a given object implements the FamilyPoolInvitationResponse interface.
 */
export function instanceOfFamilyPoolInvitationResponse(value: object): value is FamilyPoolInvitationResponse {
    return true;
}

export function FamilyPoolInvitationResponseFromJSON(json: any): FamilyPoolInvitationResponse {
    return FamilyPoolInvitationResponseFromJSONTyped(json, false);
}

export function FamilyPoolInvitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolInvitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitation': json['invitation'] == null ? undefined : FamilyPoolInvitationFromJSON(json['invitation']),
    };
}

export function FamilyPoolInvitationResponseToJSON(json: any): FamilyPoolInvitationResponse {
    return FamilyPoolInvitationResponseToJSONTyped(json, false);
}

export function FamilyPoolInvitationResponseToJSONTyped(value?: FamilyPoolInvitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitation': FamilyPoolInvitationToJSON(value['invitation']),
    };
}

